import { rest } from 'msw';

import { evaluationMock } from '../evaluation.mock';
import { API_REST_EVALUATIONS_URL } from 'config/variables';


const evaluation = rest.get(
  `${API_REST_EVALUATIONS_URL}/evaluation_cycle/me/evaluation/:clientId/:cycleId/:evaluationId`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        data: evaluationMock,
        status: 'success',
      }),
    );
  },
);

export const evaluationsHandlers = [
  /* evaluation */
];
